(function () {
  if (customElements.get('hm-flip-cards')) return;

  class HmFlipCards extends HTMLElement {
    connectedCallback() {
      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-hm-flip]'));
      if (!this.cards.length) return;

      this.first = this.cards[0];
      this.mode = this.getAttribute('data-first-anim') || 'hint';
      this.interval = Math.max(2500, Number(this.getAttribute('data-interval')) || 5000);
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.fineHover = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.autoTimer = 0;
      this.hintTimer = 0;
      this.autoOn = false;

      this.onCardActivate = this.onCardActivate.bind(this);
      this.onFineChange = this.onFineChange.bind(this);
      this.onVis = this.onVisibility.bind(this);
      this.onFirstEnter = this.onFirstEnter.bind(this);

      this.cards.forEach(function (card) {
        card.querySelectorAll('.hm-flip__toggle').forEach(function (button) {
          button.addEventListener('click', this.onCardActivate);
        }, this);
      }, this);
      if (this.first) this.first.addEventListener('pointerenter', this.onFirstEnter);

      this.fineHover.addEventListener('change', this.onFineChange);
      document.addEventListener('visibilitychange', this.onVis);

      if (!this.reduce) this.startFirst();
    }

    disconnectedCallback() {
      this.stopFirst();
      this.cards.forEach(function (card) {
        card.querySelectorAll('.hm-flip__toggle').forEach(function (button) {
          button.removeEventListener('click', this.onCardActivate);
        }, this);
      }, this);
      if (this.first) this.first.removeEventListener('pointerenter', this.onFirstEnter);
      this.fineHover.removeEventListener('change', this.onFineChange);
      document.removeEventListener('visibilitychange', this.onVis);
    }

    isFine() {
      return this.fineHover.matches;
    }

    onFineChange() {
      if (this.isFine()) {
        this.cards.forEach(function (card) {
          card.classList.remove('is-show-back');
        });
      }
    }

    onFirstEnter() {
      if (!this.first) return;
      this.first.classList.remove('is-hinting');
      this.pauseFirstBriefly();
    }

    onCardActivate(event) {
      if (event.target.closest('a')) return;
      if (this.isFine()) return;

      var card = event.currentTarget.closest('[data-hm-flip]');
      if (!card) return;
      if (card === this.first) {
        card.classList.remove('is-hinting');
        this.pauseFirstBriefly();
      }
      var open = card.classList.toggle('is-show-back');
      card.querySelectorAll('.hm-flip__toggle').forEach(function (button) {
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    startFirst() {
      if (!this.first || this.mode === 'none') return;
      if (this.mode === 'auto') this.startAuto();
      else this.startHint();
    }

    stopFirst() {
      window.clearInterval(this.autoTimer);
      window.clearTimeout(this.hintTimer);
      this.autoTimer = 0;
      this.hintTimer = 0;
      if (this.first) {
        this.first.classList.remove('is-auto-back', 'is-hinting');
      }
    }

    pauseFirstBriefly() {
      this.stopFirst();
      if (this.reduce) return;
      window.clearTimeout(this.resumeTimer);
      this.resumeTimer = window.setTimeout(this.startFirst.bind(this), this.interval);
    }

    startAuto() {
      var self = this;
      this.flipAuto(true);
      this.autoTimer = window.setInterval(function () {
        if (document.hidden) return;
        if (self.first.matches(':hover') || self.first.classList.contains('is-show-back')) return;
        self.autoOn = !self.autoOn;
        self.flipAuto(self.autoOn);
      }, this.interval);
    }

    flipAuto(showBack) {
      this.autoOn = showBack;
      this.first.classList.toggle('is-auto-back', showBack);
    }

    startHint() {
      var self = this;
      var beat = function () {
        if (document.hidden) return;
        if (self.first.matches(':hover') || self.first.classList.contains('is-show-back')) return;
        self.first.classList.remove('is-hinting');
        void self.first.offsetWidth;
        self.first.classList.add('is-hinting');
      };
      this.hintTimer = window.setTimeout(function tick() {
        beat();
        self.hintTimer = window.setTimeout(tick, self.interval);
      }, 900);
    }

    onVisibility() {
      if (document.hidden) return;
      if (!this.reduce) {
        this.stopFirst();
        this.startFirst();
      }
    }
  }

  customElements.define('hm-flip-cards', HmFlipCards);
})();
